export default __webpack_public_path__ + "static/media/renters-img.273f879c.jpg";